// src/routes/RenderRoutes.tsx
import React, { useEffect, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { RouteConfig } from "../lib/routeConfig/type";
import PrivateRoutes from "./PrivateRoutes/PrivateRoutes";
import PublicRoutes from "./PublicRoutes/PublicRoutes";
import { routeConfig } from "../lib/routeConfig/routeConfig";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import SessionManager from "services/auth/sessionManager";
import { setAuthenticated } from "store/features/user/userSlice";

interface RenderRoutesProps {
  routes: RouteConfig[];
  isAuthenticated: boolean;
}

// Helper to check if a path corresponds to a private route
// const isPrivateRouteMatch = (path: string, routes: RouteConfig[]): boolean => {
//   for (const route of routes) {
//     if (route.routetype === "private") {
//       if (matchPath({ path: route.path, end: true }, path)) {
//         return true;
//       }
//     }
//     if (route.children && route.children.length > 0) {
//       if (isPrivateRouteMatch(path, route.children)) {
//         return true;
//       }
//     }
//   }
//   return false;
// };

// const NotFoundHandler: React.FC<{ Component: React.ComponentType; allRoutes: RouteConfig[] }> = ({ Component, allRoutes }) => {
//   const location = useLocation();
//   const isPrivate = isPrivateRouteMatch(location.pathname, allRoutes);

//   if (isPrivate) {
//     return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
//   }
//   return <Component />;
// };

export const RenderRoutes = ({
  routes,
  // isAuthenticated,
}: RenderRoutesProps): React.ReactElement[] => {
  return routes.map((route) => {
    const Wrapper = route.routetype === "public" ? PublicRoutes : PrivateRoutes;
    const Element = <Wrapper Component={route.component} />;

    return (
      <Route key={route.path} path={route.path} element={Element}>
        {route.children?.length
          ? route.children.map((child) => (
              <Route
                key={child.path}
                path={child.path}
                element={<child.component />}
              />
            ))
          : null}
      </Route>
    );
  });
};
const AppRoutes = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.user);

  const routeElements = useMemo(() => {
    return <>{RenderRoutes({ routes: routeConfig, isAuthenticated })}</>;
  }, [isAuthenticated]);

  return <Routes>{routeElements}</Routes>;
};

const SingleRouting: React.FC = () => {
  const [booted, setBooted] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let alive = true;

    (async () => {
      const ok = await SessionManager.bootstrap(); // refresh using cookies
      if (!alive) return;

      dispatch(setAuthenticated(ok));
      setBooted(true);
    })();

    return () => {
      alive = false;
    };
  }, [dispatch]);

  if (!booted) return <div></div>; // create suspense or scaleton
  return (
    // <React.Suspense fallback={<div style={{ padding: 24 }}>Loading page......</div>}>
    <AppRoutes />
    // </React.Suspense>
  );
};

export default SingleRouting;

// import SessionManager from "../services/auth/sessionManager";
// import {
//   fetchSessionRequest,
//   logout as logoutAction,
// } from "../store/features/user/userActions";

// export const RenderRoutes = ({ routes }: { routes: RouteConfig[] }) => {
//   const { isAuthenticated } = useAuth();

//   const filtered = routes.filter(
//     (r) => r.routetype === routeTypeEnum.public || isAuthenticated,
//   );

//   return (
//     <Routes>
//       {filtered.map((r) => {
//         const Wrapper =
//           r.routetype === routeTypeEnum.private ? PrivateRoutes : PublicRoutes;
//         const Cmp = r.component as React.ComponentType;

//         console.log(r.path);

//         return (
//           <Route
//             key={r.path}
//             path={r.path}
//             element={<Wrapper Component={Cmp} caller={r.roles} />}
//           >
//             {r.children?.length ? <RenderRoutes routes={r.children} /> : null}
//           </Route>
//         );
//       })}
//     </Routes>
//   );
// };

// const RouteTree = () => {
//   const { isLoading } = useAuth();
//   if (isLoading) return <div></div>;

//   return (
// // <React.Suspense fallback={<div style={{ padding: 24 }}>Loading page......</div>}>
// <RenderRoutes routes={routeConfig} />
// // </React.Suspense>
//   );
// };

// export default RouteTree;

//==============================================================
// interface RenderRoutesProps {
//   routes: RouteConfig[];
//   isAuthenticated: boolean;
// }

// export const RenderRoutes = ({
//   routes,
//   isAuthenticated,
// }: RenderRoutesProps): React.ReactElement[] => {
//   const filteredRoutes = routes.filter((route) => {
//     if (route.routetype === "public") return true;
//     if (route.routetype === "private" && isAuthenticated) return true;
//     return false;
//   });

//   return filteredRoutes.map((route) => {
//     const Wrapper = route.routetype === "public" ? PublicRoutes : PrivateRoutes;
//     const Element = <Wrapper Component={route.component} />;

//     // console.log("route.path", route.path);

//     return (
//       <Route key={route.path} path={route.path} element={Element}>
//         {route.children?.length
//           ? route.children.map((child) => (
//               <Route
//                 key={child.path}
//                 path={child.path}
//                 element={<child.component />}
//               />
//             ))
//           : null}
//       </Route>
//     );
//   });
// };
// const AppRoutes = () => {
//   const { isAuthenticated } = useSelector((state: RootState) => state.user);

//   const routeElements = useMemo(() => {
//     return <>{RenderRoutes({ routes: routeConfig, isAuthenticated })}</>;
//   }, [isAuthenticated]);

//   return <Routes>{routeElements}</Routes>;
// };

// const SingleRouting: React.FC = () => {
//   // const { isAuthenticated } = useSelector((state: RootState) => state.user);

//   const dispatch = useDispatch();
//   useEffect(() => {
//     // initial hydrate attempt (authInit in saga is already doing this)
//     // if (SessionManager.getAccessToken()) {
//     //   dispatch(fetchSessionRequest());
//     // }
//     // BroadcastChannel listener - other tabs notify login/logout
//     // let bc: BroadcastChannel | null = null;
//     // if ("BroadcastChannel" in window) {
//     //   bc = new BroadcastChannel("bbps-auth");
//     //   bc.onmessage = (ev) => {
//     //     const { type } = ev.data || {};
//     //     if (type === "SET_TOKEN" && !isAuthenticated) {
//     //       // dispatch(fetchSessionRequest());
//     //     }
//     //     if (type === "CLEAR" && isAuthenticated) {
//     //       dispatch(logoutAction());
//     //     }
//     //   };
//     // }
//     // storage fallback
//     // const storageListener = (e: StorageEvent) => {
//     //   if (e.key === "bbps-auth") {
//     //     try {
//     //       const msg = JSON.parse(String(e.newValue));
//     //       if (msg?.type === "SET_TOKEN" && !isAuthenticated)
//     //         // dispatch(fetchSessionRequest());
//     //       if (msg?.type === "CLEAR" && isAuthenticated)
//     //         dispatch(logoutAction());
//     //     } catch (err) {
//     //       console.error(" storage listener ", err);
//     //     }
//     //   }
//     // };
//     // window.addEventListener("storage", storageListener);
//     // return () => {
//     //   bc?.close();
//     //   window.removeEventListener("storage", storageListener);
//     // };
//   }, [dispatch]);

//   return (
//     // <React.Suspense fallback={<div style={{ padding: 24 }}>Loading page......</div>}>
//     <AppRoutes />
//     // </React.Suspense>
//   );
// };

// export default SingleRouting;
